export default {
	URL: 'https://api-choopana.infinitum-ti.com',
	API_URL: 'https://api-choopana.infinitum-ti.com/api',
	OAPI_URL: 'https://api-choopana.infinitum-ti.com/oapi',
	// URL: 'http://localhost:3006',
	// API_URL: 'http://localhost:3006/api',
	// OAPI_URL: 'http://localhost:3006/oapi',
}
